import { defineChain as defineThirdwebChain } from "thirdweb";
// fallbackRpc is validated non-null at chain-registry module init for every
// anyspend EVM chain (see ANYSPEND_EVM_CHAINS in @b3/chain-registry). Callers
// outside the anyspend EVM set must ensure their own data shape.
// Derive icon format from URL extension. Thirdweb chain config carries an
// explicit `format` field; the old chain-networks.json had per-chain values
// (svg/png/etc.) but @b3/chain-registry only stores `logoUrl`. URL extension
// is reliable across our current chain set — 9/11 anyspend chains use .png
// (trustwallet/relay/coinmarketcap), 2 use .svg (Base, Plume from cdn.b3.fun).
function inferIconFormat(url) {
    const match = url.toLowerCase().match(/\.([a-z0-9]+)(?:\?|#|$)/);
    const ext = match?.[1];
    if (ext === "png" || ext === "jpg" || ext === "jpeg" || ext === "gif" || ext === "webp")
        return ext;
    return "svg";
}
export function toViemChain(chain) {
    if (!chain.fallbackRpc) {
        throw new Error(`toViemChain: chain ${chain.chainId} (${chain.key}) has no fallbackRpc`);
    }
    return {
        id: chain.chainId,
        name: chain.name,
        nativeCurrency: chain.nativeCurrency,
        rpcUrls: { default: { http: [chain.fallbackRpc] } },
        blockExplorers: {
            default: { name: `${chain.name} Explorer`, url: chain.explorer },
        },
        testnet: chain.isTestnet,
    };
}
export function toThirdwebChain(chain) {
    if (!chain.fallbackRpc) {
        throw new Error(`toThirdwebChain: chain ${chain.chainId} (${chain.key}) has no fallbackRpc`);
    }
    return defineThirdwebChain({
        id: chain.chainId,
        name: chain.name,
        nativeCurrency: chain.nativeCurrency,
        rpc: chain.fallbackRpc,
        icon: chain.logoUrl
            ? { url: chain.logoUrl, width: 32, height: 32, format: inferIconFormat(chain.logoUrl) }
            : undefined,
        blockExplorers: [{ name: `${chain.name} Explorer`, url: chain.explorer }],
        testnet: chain.isTestnet ? true : undefined,
    });
}
